import { AfterViewInit, Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { NominalAccount } from '../../../models/nominal-account';
import { FormControl } from '@angular/forms';
import { MatSelect } from '@angular/material/select';
import { BehaviorSubject, startWith } from 'rxjs';
import { SPACE} from '@angular/cdk/keycodes';
import { IItem } from '../../../models/group-edit-config';

@Component({
  selector: 'app-type-ahead-nominal-accounts',
  templateUrl: './type-ahead-nominal-accounts.component.html',
  styleUrls: ['./type-ahead-nominal-accounts.component.scss']
})
export class TypeAheadNominalAccountsComponent implements OnInit, AfterViewInit {
    _accounts: NominalAccount[] = [];

    // @Input() set accounts(accs: NominalAccount[]){
    //     if(this._accounts.length > 0){
    //         //already set account list - refresh it
    //         this._accounts = accs;
    //         //This will clear any search, having affect of refiltering the account list
    //         this.searchControl.setValue('');
    //     }else{
    //         this._accounts = accs;
    //     }
    // }

    @Input() control: FormControl;
    // @Input() placeholder: string = '';
    @Input() error: string = '';
    // @Input() refresh = false;
    // @Input() refreshMethod: Function;
    @Input() config: IItem;

    @ViewChild('selectControl') selectControl: MatSelect;
    @ViewChild('searchInput') searchInput: ElementRef;

    //@Output() refreshAccounts = new EventEmitter<boolean>();

    filteredAccounts: BehaviorSubject<NominalAccount[]> = new BehaviorSubject<NominalAccount[]>([]);;
    searchControl: FormControl;

    constructor() { }

    ngOnInit(): void {
        this._accounts = this.config.typeAheadData;
        this.config.updateMethod = async(acc: any[]) => {
            console.log(`Type ahead received new list of accounts.  Previously ${this._accounts.length} items, now ${acc.length} items`);
            this._accounts = acc;
            this.filteredAccounts.next(this._accounts);
        }

        const startValue = this.control.value;
        //Search control needs to have the text from the start value to get things moving
        let value;
        if(typeof startValue === 'number'){
            const f = this._accounts.find(x=>x.id === startValue) as NominalAccount;
            value = f ? f.name : '';
        }else{
            value = startValue;
        }

        this.searchControl = new FormControl(value);

        //This is where the list gets filtered by what is typed in...
        this.searchControl.valueChanges.subscribe(v => {
            //console.log("search control value changed");
            const nextList = v ? this._filter(v as string) : this._accounts.slice();
            this.filteredAccounts.next(nextList);
            //console.log("Type ahead subscriber to search box value changes");
        });
        
        //This is when the underlying form control value changes
        this.control.valueChanges.pipe(
            startWith(startValue)
        ).subscribe(v => {
            //console.log("Type ahead subscriber to form control value change");
            this.filteredAccounts.next(this._accounts.slice());
        });

       
    }

    ngAfterViewInit(): void {
        this.selectControl.openedChange.subscribe(isOpen => {
            if(isOpen){
                const p = this.selectControl.panel.nativeElement as HTMLDivElement;
                //p.scrollTop = 0;
                this.searchInput.nativeElement.select();
            }
        });

        const existingKeyDownFunction = this.selectControl._handleKeydown;
        this.selectControl._handleKeydown = (event: KeyboardEvent) => {
            if(event.keyCode === SPACE){
                return;
            }
            if(!this.selectControl.disabled){
                const ctrl = this.selectControl as any;
                this.selectControl.panelOpen ?ctrl._handleOpenKeydown(event) : ctrl._handleClosedKeydown(event);
            }
        }
    }

    private _filter(n: string): NominalAccount[] {
        const fVal = n.toLowerCase();
        return this._accounts.filter(f => f.name.toLowerCase().includes(fVal));
    }

    //Function used by autocomplete to find value to display - ie account name from account id
    displayFn(accountId: number): string {
        if(this._accounts){
            const f = this._accounts.find(x=>x.id === accountId);
            return f ? f.name : '';
        }else{
            return '';
        }
    }


    async refreshRequest(e: Event){
        e.stopPropagation();
        this.config.typeAheadHelperFunction();
    }

    onSelectListShown(showing: boolean){
        console.log("Select shown  value...", showing);
        if(showing)
        {
            
        }
    }

    //Handles the blur event to ensure selected value is account id or null
    onSearchBlur(){
        setTimeout(() => {
            const v =this.control.value;
            //console.log("typeahead checkinput value: " + v);
            if (v !== '') {
                //Is it a number?
                //console.log("typeahead value is not empty string");
                const parsedV = parseInt(v);
                if(!isNaN(parsedV)){
                    // console.log("typeahead parsed v is a number: " + parsedV);
                    return;
                }
            }
            this.control.setValue(null);
          }, 300);
    }

    onSearchKey(searchTerm){

    }
}
